import { Asset, Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import omit from 'lodash/omit';

// This function has been moved from `AppUtils`
export default function cleanUnusedAssets({ assets = {}, ...otherDolan }: Dolan): Record<string, Asset> {
  // Dolan JSON without the assets dictionary, to able find only assets that is used
  const otherDolanJson = JSON.stringify(otherDolan);

  const regexAssetManager =
    /ag-asset:\/\/([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})/g;
  const usedUris = new Set(otherDolanJson.match(regexAssetManager));
  const keysToRemove = Object.keys(assets).filter((uri) => !usedUris.has(`ag-asset://${uri}`));
  // Ensure that the reference to the assets remains the same if there are no actual changes
  return keysToRemove.length > 0 ? omit(assets, keysToRemove) : assets;
}
